import { gql } from "@apollo/client";

export const GET_SHOP_FEATURES_QUERY = gql`
    query SystemFeatureShop {
        systemFeatureShop(id: "U3lzdGVtRmVhdHVyZVNob3BOb2RlOjE=") {
            waitlist
        }
    }
`;

export const GET_CLASS_WAITLIST_QUERY = gql`
    query GetClassWaitlist($scheduleItem: ID!, $date: Date!) {
        scheduleClass(scheduleItemId: $scheduleItem, date: $date) {
            scheduleItemId
            spaces
            countBooked
            availableSpacesTotal
            waitlistEnabled
            waitlistCount
            hasWaitlist
        }
        classWaitlist(classScheduleItem: $scheduleItem, classDate: $date) {
            edges {
                node {
                    id
                    account {
                        id
                        fullName
                        email
                    }
                    waitlistPosition
                    joinedWaitlistAt
                    attendanceType
                    accountClasspass {
                        id
                        organizationClasspass {
                            name
                        }
                    }
                    accountSubscription {
                        id
                        organizationSubscription {
                            name
                        }
                    }
                    canCancelWaitlist
                    canPromoteFromWaitlist
                }
            }
        }
    }
`;

export const PROMOTE_FROM_WAITLIST_MUTATION = gql`
    mutation PromoteFromWaitlist($scheduleItemAttendance: ID!) {
        promoteFromWaitlist(scheduleItemAttendance: $scheduleItemAttendance) {
            scheduleItemAttendance {
                id
                bookingStatus
                waitlistPosition
                isWaitlisted
            }
        }
    }
`;

export const CANCEL_WAITLIST_MUTATION = gql`
    mutation CancelWaitlist($scheduleItemAttendance: ID!) {
        cancelWaitlist(scheduleItemAttendance: $scheduleItemAttendance) {
            scheduleItemAttendance {
                id
                bookingStatus
                isWaitlisted
            }
        }
    }
`;

export const BULK_PROMOTE_FROM_WAITLIST_MUTATION = gql`
    mutation BulkPromoteFromWaitlist($scheduleItemAttendances: [ID!]!) {
        bulkPromoteFromWaitlist(
            scheduleItemAttendances: $scheduleItemAttendances
        ) {
            success
            promotedCount
            failedCount
            errors
        }
    }
`;

export const BULK_CANCEL_WAITLIST_MUTATION = gql`
    mutation BulkCancelWaitlist($scheduleItemAttendances: [ID!]!) {
        bulkCancelWaitlist(scheduleItemAttendances: $scheduleItemAttendances) {
            success
            cancelledCount
            failedCount
            errors
        }
    }
`;
